import { BaseService, type PaginationRequest, type ResponseMessage } from "@kiddocare-platform/portal-common/base";
import type { City, Country, Region, Zip } from "@kiddocare-platform/portal-common/core";

export class CoreTerritoryService extends BaseService {

  public async CitiesSearch(body?: PaginationRequest): Promise<ResponseMessage<City[]>> {
    try {
      const response = await this.AxiosInstance.post('/parent/territory/cities/search', body);
      return response.data;
    }
    catch (error: any) {
      console.log(error);
      throw new Error(error);
    }
  }

  public async RegionSearch(body?: PaginationRequest): Promise<ResponseMessage<Region[]>> {
    try {
      const response = await this.AxiosInstance.post('/parent/territory/regions/search', body);
      return response.data;
    }
    catch (error: any) {
      console.log(error);
      throw new Error(error);
    }
  }

  public async ProvincesSearch(body?: PaginationRequest): Promise<ResponseMessage<Region[]>> {
    try {
      const response = await this.AxiosInstance.post('/parent/territory/provinces/search', body);
      return response.data;
    }
    catch (error: any) {
      console.log(error);
      throw new Error(error);
    }
  }

  public async ZipsSearch(body?: PaginationRequest): Promise<ResponseMessage<Zip[]>> {
    try {
      const response = await this.AxiosInstance.post('/parent/territory/zips/search', body);
      return response.data;
    }
    catch (error: any) {
      console.log(error);
      throw new Error(error);
    }
  }

  public async CountrySearch(body?: PaginationRequest): Promise<ResponseMessage<Country[]>> {
    try {
      const response = await this.AxiosInstance.post('/parent/territory/country/search', body);
      return response.data;
    }
    catch (error: any) {
      console.log(error);
      throw new Error(error);
    }
  }

}